import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { TermsServiceComponent } from "./terms-service.component";

const routes: Routes = [
    {
        path: 'termsService',
        component: TermsServiceComponent,
        canLoad: [AuthGuard],
    }
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class TermsServiceRoutingModule {}